const POLAND_REDIRECT_KEY = 'renpho-geolocation-pl-redirected';
const MANUAL_LANGUAGE_PREFERENCE_KEY = 'renpho-geolocation-language-manual';

class GeolocationLocalizationPrompt extends HTMLElement {
  connectedCallback() {
    document.addEventListener('change', this.recordManualLanguagePreference);
    this.loadSuggestion();
  }

  disconnectedCallback() {
    document.removeEventListener('change', this.recordManualLanguagePreference);
  }

  recordManualLanguagePreference = (event) => {
    const languageInput = event.target;
    if (!(languageInput instanceof HTMLSelectElement) || languageInput.name !== 'language_code') return;

    try {
      window.localStorage.setItem(MANUAL_LANGUAGE_PREFERENCE_KEY, languageInput.value);
    } catch {
      // If storage is unavailable, preserve the current session-only behavior.
    }
  };

  hasManualLanguagePreference() {
    try {
      return Boolean(window.localStorage.getItem(MANUAL_LANGUAGE_PREFERENCE_KEY));
    } catch {
      return false;
    }
  }

  async loadSuggestion() {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const url = new URL(`${root}browsing_context_suggestions.json`, window.location.origin);
      url.searchParams.set('country[enabled]', 'true');

      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) return;

      const data = await response.json();
      const suggestedCountry = data.suggestions?.[0]?.parts?.country?.handle?.toUpperCase();
      if (suggestedCountry !== 'PL') return;
      if (window.location.pathname === '/pl' || window.location.pathname.startsWith('/pl/')) return;
      if (this.hasManualLanguagePreference()) return;
      if (window.sessionStorage.getItem(POLAND_REDIRECT_KEY)) return;

      window.sessionStorage.setItem(POLAND_REDIRECT_KEY, 'true');
      this.switchToPolandMarket();
    } catch {
      // Keep the existing storefront context if Shopify cannot provide a suggestion.
    }
  }

  switchToPolandMarket() {
    const form = this.querySelector('[data-localization-form]');
    const countryInput = this.querySelector('[name="country_code"]');
    const languageInput = this.querySelector('[name="language_code"]');
    const returnToInput = this.querySelector('[name="return_to"]');
    if (!form || !countryInput || !languageInput || !returnToInput) return;

    countryInput.value = 'PL';
    languageInput.disabled = false;
    languageInput.value = 'pl';
    returnToInput.value = '/pl';
    form.submit();
  }
}

if (!customElements.get('geolocation-localization-prompt')) {
  customElements.define('geolocation-localization-prompt', GeolocationLocalizationPrompt);
}
